import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** Server-side job/CTC-job option search for pickers. Pass a query term, or
 * ids/ctcJobNumbers to hydrate an already-selected set. */
export function useJobSearch(args: {
  query?: string | null;
  ids?: number[] | null;
  ctcJobNumbers?: string[] | null;
  enabled?: boolean;
}) {
  const {
    query = null,
    ids = null,
    ctcJobNumbers = null,
    enabled = true,
  } = args;
  return useQuery({
    queryKey: queryKeys.jobs.search(
      JSON.stringify({ query, ids, ctcJobNumbers }),
    ),
    queryFn: ({ signal }) =>
      jobApiClient.searchJobs(query, ids, ctcJobNumbers, toCancelToken(signal)),
    enabled,
    staleTime: 60_000,
    placeholderData: (prev) => prev,
    meta: { errorContext: 'job search' },
  });
}
